import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterUnidadesAdmAsync,
	enviarUnidadeAdmAsync,
	editarUnidadeAdmAsync,
	downloadLista,
	buscarCepAsync
}

export const obterUnidadesAdmAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/UnidadeAdm/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarUnidadeAdmAsync = async (descricao, numeroDaUnidade, contratante, enderecos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao, numeroDaUnidade, contratante, enderecos })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/UnidadeAdm`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const buscarCepAsync = async (cep) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() }
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Endereco/consultaCep/` + cep, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarUnidadeAdmAsync = async (id, descricao, numeroDaUnidade, contratante, enderecos, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, numeroDaUnidade, contratante, enderecos, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/UnidadeAdm/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/UnidadeAdm/downloadUnidadesAdm`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'unidadesAdm' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}